import { isNullOrEmpty } from "../../utils/isNullOrEmpty";

const mainContainerClassName = ".main-container";

export function scrollToTopic(rootNode, selectedItem) {
  const target = findMatchedAnchor(rootNode, selectedItem);
  if (target) {
    applyScrollPaddingTop();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
    revertScrollPaddingTop();
  }
}

// This is to apply CSS scroll padding to main container and all children nodes
// This will make sure scrollIntoView (start position) to display just below the nav bar
function applyScrollPaddingTop() {
  const mainContainers = Array.from(
    document.querySelectorAll(mainContainerClassName),
  );
  if (mainContainers.length > 0) {
    mainContainers[0].classList.add("scrollPadding");
  }
}

// This is to revert CSS scroll padding to main container and all children nodes
function revertScrollPaddingTop() {
  const mainContainers = Array.from(
    document.querySelectorAll(mainContainerClassName),
  );
  if (mainContainers.length > 0) {
    mainContainers[0].classList.remove("scrollPadding");
  }
}

function findMatchedAnchor(rootNode, selectedItem) {
  let targetElement;
  const decoded = decodeURIComponent(selectedItem.id);
  targetElement = Array.from(
    rootNode.querySelectorAll(`[filepath='${decoded}']`),
  ).find(
    (el) =>
      el.textContent.trim().toLowerCase() ===
        selectedItem.title.toLowerCase() && isVisible(el),
  );

  if (!targetElement) {
    targetElement = Array.from(rootNode.querySelectorAll("ditatitle, h2")).find(
      (el) =>
        normalise(el.textContent) === normalise(selectedItem.title) &&
        isVisible(el),
    );
  }
  return targetElement;
}

/*
 * This is a helper function to remove newline inside a string
 */
function normalise(str) {
  if (isNullOrEmpty(str)) return "";
  return str.replace(/\s+/g, " ").trim().toLowerCase();
}

function isVisible(el) {
  if (!el) return false;
  const style = window.getComputedStyle(el);

  return (
    style.display !== "none" &&
    style.visibility !== "hidden" &&
    style.opacity !== "0" &&
    el.offsetParent !== null
  );
}

// This is to find the page that current user is viewing
// and then match to the toc items to find the active item and highlight it
export function findActiveItem(node, currentSection) {
  if (isNullOrEmpty(currentSection)) return null;
  const decoded = decodeURIComponent(node.id);
  if (
    (node.title && node.title.toLowerCase() === currentSection.title) ||
    decoded === currentSection.filePath
  ) {
    return node;
  }

  if (Array.isArray(node.children)) {
    for (const child of node.children) {
      const result = findActiveItem(child, currentSection);
      if (result) return result;
    }
  }
  return null;
}

export function isSameItem(item1, item2) {
  const attributes = ["id", "title"];
  return attributes.every((attr) => {
    return compareItemForAttr(item1, item2, attr);
  });
}

export function compareItemForAttr(item1, item2, attribute) {
  if (isNullOrEmpty(item1) || isNullOrEmpty(item2)) return false;
  const hasAttr1 = item1.hasOwnProperty(attribute);
  const hasAttr2 = item2.hasOwnProperty(attribute);

  if (hasAttr1 && hasAttr2) {
    if (attribute === "msPath") {
      return (
        cleanMsPath(item1[attribute].toLowerCase()) ===
        cleanMsPath(item2[attribute].toLowerCase())
      );
    }
    return item1[attribute].toLowerCase() === item2[attribute].toLowerCase();
  }
  return !hasAttr1 && !hasAttr2;
}

export function cleanMsPath(url) {
  const urlSearchParams = new URLSearchParams(url);
  const sectionId = urlSearchParams.get("sectionid");
  if (sectionId) {
    const hash = sectionId.split("#")[0];
    if (sectionId?.endsWith(`#${hash}`)) {
      url = url.replace(`#${hash}`, "");
    }
  }
  return url;
}
